import { render, staticRenderFns } from "./LeftMenuItem.vue?vue&type=template&id=01460aca"
import script from "./LeftMenuItem.vue?vue&type=script&lang=js"
export * from "./LeftMenuItem.vue?vue&type=script&lang=js"
import style0 from "./LeftMenuItem.vue?vue&type=style&index=0&id=01460aca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports